import React, { useState, useRef, useEffect } from "react";
import Plan from "./Plan/Plan";
import WhyUs from "./WhyUs/WhyUs";
import WelcomeNew from "./WelcomeNew/WelcomeNew";
import OurLegacy from "./OurLegacy/OurPolicy";
import Products from "./Product/Products";
import "../../Components/Home/WhyUs/WhyUs.css";
import Welcome from "./Welcome/Welcome";
import PlatformNew from "./PlatformNew/PlatformNew";
import OurTools from "./Ourtools/OurTools";
import TheMarket from "./TheMarket/TheMarket";
import Learning from './learning/Learning';
import derivatives from "../../Images/derivatives-learn.png";
import startguidemutualfunds from "../../Images/startguide-mutualfunds.png";
import deversifymarket from "../../Images/deversify-market.png";
import Quotes from "./Testimonials/Quotes";
import Insights from "./Insights/Insights";
import { useLocation } from 'react-router-dom';
import { useCookies } from "react-cookie";
import TrackApi from "../Activity_Track/TrackApi";
//import ProductEquity from "../ProductEquity/ProductEquity";

function Home() {
  const observed = useRef(null);
  const location = useLocation();

  const [cookies, setCookie] = useCookies(['LeadId']);

  const trackData=(id)=>{
    const payloadData={
      "RelatedProspectId":id,
      "ActivityNote": "Your home Note",
      "mx_Custom_1": "Home",
      "mx_Custom_2": "Your  home page Note",
      "mx_CustomObject_81":window.location.href
     }
     TrackApi(payloadData);
  }
  useEffect(()=>{
  
if(cookies && cookies.RelatedProspectId){
  trackData(cookies.RelatedProspectId);
}
    
  })

  useEffect(() => {
    if (location.state != null && location.state.plan != '') {
      let widthWindow = window.matchMedia("(max-width: 550px)")
      if (widthWindow.matches) {
        window.scrollTo({
          top: (observed.current.offsetTop + 1360),
          behavior: 'smooth',
        });
      }
      else {
        window.scrollTo({
          top: (observed.current.offsetTop + 600),
          behavior: 'smooth',
        });
      }
    }
  }, []);
  return (
    <>
      {/* <Welcome />
      <TheMarket />
      <WhyUs />
      <Products />
      <Learning />
      <div ref={observed} className="App">
        <PlatformNew />
      </div>
      <OurTools />
      <OurLegacy />
      <Quotes /> */}

    {/* <Plan /> */}
      {/* <ProductEquity /> */}
      {/* <Platforms /> */}
      {/* <OurPolicy /> */}
      {/* _______________________________________________________________________________________________________________ */}


      <WelcomeNew />
      <div ref={observed} className="App">
        <PlatformNew />
      </div>
      <Learning />
      <Insights/>
      
      {/* <TheMarket /> */}
      <Quotes />
      <OurLegacy />

    </>
  );
}
export default Home;
